<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay">
      <div class="modal-content" style="max-width: 500px">
        <div class="modal-header">
          <h3>{{ s__('Boards|Confirm Transition') }}</h3>
          <button class="modal-close" @click="handleCancel" aria-label="Close">×</button>
        </div>
        <div class="modal-body">
          <p>
            {{ s__('Boards|Confirm the Transition') }} <strong>{{ transition.name }}</strong>
            {{ s__('Boards|to status') }} <strong>{{ targetStatus.name }}</strong>
          </p>
          <p
            v-if="isTransitionDisabled"
            class="checklist-warning"
            style="color: #d32f2f; margin-top: 12px; font-size: 13px"
          >
            ⚠️ {{ s__('Boards|Checklist must be completed before transitioning to this status') }}
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="handleCancel">
            {{ s__('Boards|Cancel') }}
          </button>
          <button
            type="button"
            class="btn-primary"
            @click="handleConfirm"
            :disabled="executing || isTransitionDisabled"
          >
            <span v-if="executing">{{ s__('Boards|Executing...') }}</span>
            <span v-else>{{ s__('Boards|Confirm') }}</span>
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { __, s__ } from '@/locale'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: { type: Boolean, default: false },
  transition: { type: Object, default: null },
  targetStatus: { type: Object, default: null },
  task: { type: Object, default: null },
  checklistsEnabled: { type: Boolean, default: false },
  executing: { type: Boolean, default: false },
})

const emit = defineEmits(['confirm', 'cancel'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleConfirm() {
  emit('confirm')
}

function handleCancel() {
  emit('cancel')
}

// Check if transition should be disabled due to checklist requirements
const isTransitionDisabled = computed(() => {
  if (!props.transition?.targetStatus?.requiresCompletedChecklists) return false
  if (!props.checklistsEnabled) return false
  if (!props.task?.checklist) return false
  if (props.task?.checklistCompleted) return false
  return true
})
</script>

<style scoped>
/* Component-specific: max-width override */
.modal-content {
  max-width: 500px;
}

.modal-body p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}

.btn-primary,
.btn-secondary {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid;
}

.btn-primary {
  background: #1976d2;
  color: #fff;
  border-color: #1976d2;
}

.btn-primary:hover:not(:disabled) {
  background: #1565c0;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: #fff;
  color: #666;
  border-color: #ccc;
}

.btn-secondary:hover {
  background: #f5f5f5;
}
</style>
